import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getInbound = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Inbound/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createInbound = (payload) => {
  return axios.post(`${URL_ORI}/api/Inbound`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdInbound = (id) => {
  return axios
    .get(`${URL_ORI}/api/Inbound/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateInbound = (payload) => {
  return axios.put(`${URL_ORI}/api/Inbound`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateInboundSetStatus = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Inbound/setstatus`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateInboundCancel = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Inbound/InboundCancel`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateInboundConfirm = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Inbound/InboundConfirm`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateInboundAmend = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Inbound/InboundAmen`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteInbound = (payload) => {
  return axios.delete(`${URL_ORI}/api/Inbound`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

// Vehicle

export const getVehicle = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Vehicle/Search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getVehicleInboundWorkflow = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Vehicle/SearchInboundWorkflow`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getVehicleOutboundWorkflow = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Vehicle/SearchOutboundWorkflow`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getVehicleOutbound = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Outbound/retriveVehicle`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getVehicleInfoUpdate = (payload) => {
  return axios
    .get(`${URL_ORI}/api/InfoUpdateWorkflow/Search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getVehicleStocktake = (payload) => {
  return axios
    .get(`${URL_ORI}/api/StockTakeWorkflow/Search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getVehicleMaintenace = (payload) => {
  return axios
    .get(`${URL_ORI}/api/MaintenanceWorkflow/SearchMaintenanceWorkflow`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const getVehicleMovement = (payload) => {
  return axios
    .get(`${URL_ORI}/api/MovementWorkflow/SearchWorkflowMovement`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const geListInspection = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Vehicle/GetMasterInspect`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createVehicle = (payload) => {
  return axios.post(`${URL_ORI}/api/Vehicle`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const createVehicleUpload = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Vehicle/ProssesVehicle`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getIdVehicle = (id) => {
  return axios
    .get(`${URL_ORI}/api/Vehicle/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicle = (payload) => {
  return axios.put(`${URL_ORI}/api/Vehicle`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const updateVehicleTSA = (payload) => {
  return axios.put(`${URL_ORI}/api/tsa`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const updateVehicleRCI = (payload) => {
  return axios.put(`${URL_ORI}/api/RCI`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateVehicleMaintenance = (payload) => {
  return axios
    .put(`${URL_ORI}/api/MaintenanceWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleInspection = (payload) => {
  return axios
    .put(`${URL_ORI}/api/InspectionWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleRepdiin = (payload) => {
  return axios.put(`${URL_ORI}/api/RePDIINWorkflow`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const updateVehicleRepdiout = (payload) => {
  return axios
    .put(`${URL_ORI}/api/RePDIOUTWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleInfoUpdate = (payload) => {
  return axios
    .put(`${URL_ORI}/api/InfoUpdateWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleStocktake = (payload) => {
  return axios
    .put(`${URL_ORI}/api/StockTakeWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehiclePicking = (payload) => {
  return axios.put(`${URL_ORI}/api/Picking`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const updateVehicleHandover = (payload) => {
  return axios.put(`${URL_ORI}/api/Handover`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const updateVehicleBTS = (payload) => {
  return axios.put(`${URL_ORI}/api/BTS`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const updateVehiclePDI = (payload) => {
  return axios.put(`${URL_ORI}/api/PDI`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const updateVehicleMovementWorkflow = (payload) => {
  return axios
    .put(`${URL_ORI}/api/MovementWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateVehicleHandoverWorkflow = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Handover/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleBTSWorkflow = (payload) => {
  return axios
    .put(`${URL_ORI}/api/BTS/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateVehicleConfirm = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Vehicle/confirmAll`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleConfirmInfoUpdate = (payload) => {
  return axios
    .put(`${URL_ORI}/api/InfoUpdateWorkflow/ConfirmAll`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleConfirmBTS = (payload) => {
  return axios.put(`${URL_ORI}/api/BTS/ConfirmAll`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateVehicleConfirmMovement = (payload) => {
  return axios
    .put(`${URL_ORI}/api/MovementWorkflow/ConfirmAll`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleCompleteMovement = (payload) => {
  return axios
    .put(`${URL_ORI}/api/MovementWorkflow/Complete`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleCompleteInfoUpdate = (payload) => {
  return axios
    .put(`${URL_ORI}/api/InfoUpdateWorkflow/Complete`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleConfirmStocktake = (payload) => {
  return axios
    .put(`${URL_ORI}/api/StockTakeWorkflow/ConfirmAll`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleCompleteStocktake = (payload) => {
  return axios
    .put(`${URL_ORI}/api/StockTakeWorkflow/Complete`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleConfirmMaintenance = (payload) => {
  return axios
    .put(`${URL_ORI}/api/MaintenanceWorkflow/ConfirmAll`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleCompleteMaintenance = (payload) => {
  return axios
    .put(`${URL_ORI}/api/MaintenanceWorkflow/Complete`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleConfirmInspection = (payload) => {
  return axios
    .put(`${URL_ORI}/api/InspectionWorkflow/ConfirmAll`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleConfirmREPDIIN = (payload) => {
  return axios
    .put(`${URL_ORI}/api/REPDIINWorkflow/ConfirmAll`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleCompleteREPDIIN = (payload) => {
  return axios
    .put(`${URL_ORI}/api/REPDIINWorkflow/Complete`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleConfirmREPDIOUT = (payload) => {
  return axios
    .put(`${URL_ORI}/api/REPDIOUTWorkflow/ConfirmAll`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateVehicleComplate = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Vehicle/complete`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteVehicle = (payload) => {
  return axios.delete(`${URL_ORI}/api/Vehicle`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const deleteVehicleWorkFlow = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Vehicle/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteVehicleWorkFlowTSA = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/TSA/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const deleteVehicleWorkFlowRCI = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/RCI/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const deleteVehicleWorkFlowStocktake = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/StockTakeWorkflow/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const deleteVehicleWorkFlowMaintenance = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/MaintenanceWorkflow/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const deleteVehicleWorkFlowInspection = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/InspectionWorkflow/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteVehicleWorkFlowRePdiin = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/RePDIINWorkflow/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteVehicleWorkFlowRePdiout = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/RePDIOUTWorkflow/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteVehicleWorkFlowInfoUpdate = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/InfoUpdateWorkflow/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteVehicleWorkFlowPicking = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Picking/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const deleteVehicleWorkFlowHandover = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Handover/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const deleteVehicleWorkFlowBTS = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/BTS/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const deleteVehicleWorkFlowPDI = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/PDI/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteVehicleWorkFlowMovement = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/MovementWorkflow/DeleteFromWorkflow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const uploadFile = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(`${URL_ORI}/api/Vehicle/uploadvehicle?object_id=${id}`, formData)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadFileRCI = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(`${URL_ORI}/api/Vehicle/uploadvehicleRCI?object_id=${id}`, formData)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadFilePDIIN = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(`${URL_ORI}/api/Vehicle/uploadvehiclePDIIN?object_id=${id}`, formData)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadFilePDIOUT = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/Vehicle/uploadvehiclePDIIOUT?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadFileTSA = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(`${URL_ORI}/api/Vehicle/uploadvehicleTSA?object_id=${id}`, formData)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getIdVehicleSeperator = (id) => {
  return axios
    .get(`${URL_ORI}/api/Vehicle/GetDataBySeperator/${id}`)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getIdVehicleSeperatorInfoUpdate = (id) => {
  return axios
    .get(`${URL_ORI}/api/InfoUpdateWorkflow/GetDataBySeperator/${id}`)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getIdVehicleSeperatorMaintenance = (id) => {
  return axios
    .get(`${URL_ORI}/api/MaintenanceWorkflow/getMaintenanceSeparator/${id}`)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getMaintenanceActivityDetail = (id) => {
  return axios
    .get(`${URL_ORI}/api/MaintenanceWorkflow/getmaintenanceactivitydetail/${id}`)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
}

export const getIdVehicleSeperatorStocktake = (id) => {
  return axios
    .get(`${URL_ORI}/api/StockTakeWorkflow/getStockTakeSeparator/${id}`)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// filter
export const getFilter = (payload) => {
  return axios
    .get(`${URL_ORI}/api/filter/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createFilter = (payload) => {
  return axios.post(`${URL_ORI}/api/filter`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteFilter = (payload) => {
  return axios.delete(`${URL_ORI}/api/filter`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const getFile = (id, type) => {
  return axios
    .get(
      `${URL_ORI}/api/Vehicle/DownloadTemplateExcel?id=${id}&file_type=${type}`,
      {
        // params: payload,
        // responseType: "blob",
      }
    )
    .catch((error) => {
      if (error.response) {
        console.log(error.response, "eerorr");

        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const getFileBlob = (id, type) => {
  return axios
    .get(
      `${URL_ORI}/api/Vehicle/DownloadTemplateExcel?id=${id}&file_type=${type}`,
      {
        // params: payload,
        responseType: "blob",
      }
    )
    .catch((error) => {
      if (error.response) {
        console.log(error.response, "eerorr");

        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Vehicle

export const getPrint = (payload) => {
  return axios
    .get(`${URL_ORI}/api/PrintMonitoring/preview`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createPrint = (vin, labeltpl_id, copies) => {
  return axios
    .post(
      `${URL_ORI}/api/PrintMonitoring?vin=${vin}&labeltpl_id=${labeltpl_id}&copy=${copies}`
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Generate Excel
export const getGenerateExcelBlob = (payload) => {
  return axios
    .post(
      `${URL_ORI}/api/RDM/GenerateExcel`,
      payload,
      {
        responseType: 'blob',
      }
    )
    .catch((error) => {
      if (error.response) {
        console.log(error.response, "eerorr");

        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
